import React from 'react';
import { connect } from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';
import { renderAutoCompleteSingleSelect, renderCheckBox, renderDateField, renderTextField } from '../../components/reduxFields';
import { RaisedButton } from 'material-ui';
import IconButton from 'material-ui/IconButton';
import { get_All_ERA_Claims, get_EDI_GateWays, EDI835Download , bulk_Download_ERA_Details} from './actions/manageEraActions'
import moment from 'moment';
import { delay } from 'lodash';
import classNames from 'classnames';
import { getMasterData } from "../Dashboards/actions/StaffDashboardActions"
import history from '../../history';
import { getIscalledFromERAMouleFlag } from '../Billing/components/manageClaims/actions/ManageClaimActions';
import Tooltip from '../../components/Tooltip';
export const stylescss = {
  checkbox: {
    marginBottom: 16,
  },
};

class ManageERA extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ERADate: "",
      clearinghouseName: "",
      checkNumber: "",
      payer: "",
      status: "",
      selectedClaims:[],
      selectedClaimsBatchIds:[]
    }
  };


  componentDidMount() {
    this.loadData()
    let masterData = {
      'masterdata': 'MASTERINSURANCECOMPANY',
    };
    this.props.getMasterData(masterData);
    this.getAllEDIdGateWayData()

  }


  loadData = () => {
    let searchObj = {
      ERADate: this.state.ERADate || '',
      ClearinghouseName: this.state.clearinghouseName || "",
      CheckNumber: this.state.checkNumber || "",
      Payer: this.state.payer || "",
      Status: this.state.status || ""
    }
    this.props.get_All_ERA_Claims(searchObj);
  }

  getAllEDIdGateWayData = () => {
    let searchObj = {
      pageNumber: 1,
      pageSize: 20,
      sortColumn: 'id',
      sortOrder: 'desc'
    }
    this.props.get_EDI_GateWays(searchObj)
  }

  handleFilter = () => {
    this.loadData();
  }


  handleReset = () => {
    this.setState({
      ERADate:  "",
      clearinghouseName: "",
      checkNumber: "",
      payer: "",
      status: "",
    })
    this.props.dispatch(change('MANAGEERAFORM', 'ClearinghouseName', null))
    this.props.dispatch(change('MANAGEERAFORM', 'checkNumber', null))
    this.props.dispatch(change('MANAGEERAFORM', 'PayerName', null))
    this.props.dispatch(change('MANAGEERAFORM', 'Status', null))
    this.props.dispatch(change('MANAGEERAFORM', 'Chkclaim', false))
    this.uncheckAllClaims()
    delay(() => this.loadData(), 200)
  }

  onDateChange = (input, value) => {
    input.onChange(moment(value).format());
    this.setState({ ERADate: moment(value).format("MM/DD/YYYY")});
  }

  handleClearingHouserNameRequest = (input, selectedValue) => {
    this.uncheckAllClaims()
    input.onChange(selectedValue.value);
    this.setState({ clearinghouseName: selectedValue.label })
  }

  handlePayerNameRequest = (input, selectedValue) => {
    this.uncheckAllClaims()
    input.onChange(selectedValue.value);
    this.setState({ payer: selectedValue.label })
  }

  handleStatusRequest = (input, selectedValue) => {
    this.uncheckAllClaims()
    input.onChange(selectedValue.value);
    this.setState({ status: selectedValue.label })
  }

  checkNumberChangeHandler = (event) => {
    this.setState({ checkNumber: event.target.value })
  }

  CheckClaim(e, index, data) {  
    let isClaimChecked = e.target.checked;
    let selectedClaims = [...this.state.selectedClaims];
    let selectedClaimsBatchIds = [...this.state.selectedClaimsBatchIds]
    if(isClaimChecked){
      selectedClaims.push(data);
      selectedClaimsBatchIds.push(index.batchId)
      this.setState({selectedClaims,selectedClaimsBatchIds})
    }
    if (!isClaimChecked) {
      let index = selectedClaims.indexOf(data)
      let batchIdIndex = selectedClaimsBatchIds.indexOf(index.batchId)
      selectedClaims.splice(index,1);
      selectedClaimsBatchIds.splice(batchIdIndex,1)
      this.setState({selectedClaims,selectedClaimsBatchIds})
      this.props.dispatch(change('MANAGEERAFORM', 'Chkclaim', false))
    }

  }

  uncheckAllClaims = () => {
    let selectedClaims = [];
    let allERAClaims = this.props.All_ERA_Claims.data.eRAResponseModels;
    allERAClaims.forEach((claim, claimIndex) => {
      let claimIdCheck = `Claims[${claimIndex}].Chk`;
      this.props.dispatch(change('MANAGEERAFORM', claimIdCheck, false));
    });
    this.setState({bulkDownLoadFlag:false,selectedClaims})
  }
  checkAllClaims = (e) => {
    let isAllClaimChecked = e.target.checked;
    let allERAClaims = this.props.All_ERA_Claims.data.eRAResponseModels; // Get all claims data
    let selectedClaims = [];
    let selectedClaimsBatchIds = []

    allERAClaims.forEach((claim)=>{
      selectedClaimsBatchIds.push(claim.batchId)
    })
    allERAClaims.forEach((claim, claimIndex) => {
      let claimIdCheck = `Claims[${claimIndex}].Chk`;

      if (isAllClaimChecked) {
        selectedClaims.push(claimIndex)
        this.setState({selectedClaims,selectedClaimsBatchIds})
        // If the "Select All" checkbox is checked, add each claim to the selectedClaims
        this.props.dispatch(change('MANAGEERAFORM', claimIdCheck, true));
      } else {
        selectedClaims = []
        selectedClaimsBatchIds = []
        this.setState({selectedClaims,selectedClaimsBatchIds})
        // If the "Select All" checkbox is unchecked, remove each claim from the selectedClaims
        this.props.dispatch(change('MANAGEERAFORM', claimIdCheck, false));
      }
    });

  }

  handleExpandRow = (claimId) => {
    this.setState({ ClaimId: claimId });
    let display = this.refs['expandedClass' + claimId].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + claimId].style.display = 'table-row';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + claimId].style.display = 'none';
      this.refs['expClass' + claimId].className = 'classExpand fa fa-ellipsis-h';
    }
  }

  downloadERAFile = (batchId, ERAName) => {
    this.props.EDI835Download(batchId, ERAName);
  }

  actionClickHandler = (dos,batchId) => {
    history.push('/claims')
    this.props.getIscalledFromERAMouleFlag({ flag: true, batchId: batchId,dos:dos })
  }

  bulkDownloadERADetails = ()=>{
    let searchObj = {
      ERADate: this.state.ERADate || '',
      ClearinghouseName: this.state.clearinghouseName || "",
      CheckNumber: this.state.checkNumber || "",
      Payer: this.state.payer || "",
      Status: this.state.status || "",
      BatchId:this.state.selectedClaimsBatchIds
    }
    this.props.bulk_Download_ERA_Details(searchObj)
  }

  render() {
    const tableClass = classNames({
      'table': true,
      'tablePaymentledger': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });

    const tableClass1 = classNames({
      'table': true,
      'middletable': true,
      'customtable': true,
      'colorChange': true,
    });

    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    const { handleSubmit } = this.props
    return (
      <div>
        <h2 className="page_title">Manage ERA</h2>

        <div>
          <div className="clearfix"></div>
          <div className="readmin-panel">
            <div className="panel-body">
              <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleFilter)}>
                <div className="row mtm-20">
                  <div className="col-sm-4">
                    <Field name="ERADate"
                      placeholder="ERA Date"
                      locale="en-US"
                      selected={this.state.ERADate}
                      onDateChange={this.onDateChange}
                      openToYearSelection={true}
                      component={renderDateField} />
                  </div>

                  <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="ClearinghouseName"
                      label="Clearinghouse Name"
                      handleNewRequest={this.handleClearingHouserNameRequest}
                      options={this.props.All_EDI_GATEWAYS && this.props.All_EDI_GATEWAYS.data.map((ele) => ({
                        id: ele.id,
                        value: ele.clearingHouseName
                      }))}
                      component={renderAutoCompleteSingleSelect} />
                  </div>

                  <div className="col-sm-4">
                    <Field
                      autoFocus={true}
                      name="checkNumber"
                      type='text'
                      floatingLabelText="Check Number"
                      onBlur={(event) => this.checkNumberChangeHandler(event)}
                      component={renderTextField} />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="PayerName"
                      label="Payer Name"
                      handleNewRequest={this.handlePayerNameRequest}
                      options={this.props.masterData && this.props.masterData.insuranceCompanies||[].map((ele) => ({
                        id: ele.id,
                        value: ele.name
                      }))}
                      component={renderAutoCompleteSingleSelect} />
                  </div>

                  <div className="col-sm-4 insfield mt-35">
                    <Field
                      name="Status"
                      label="Status"
                      handleNewRequest={this.handleStatusRequest}
                      options={[{ 'id': 0, 'value': "Fully Posted" }, { 'id': 1, 'value': "Partially Posted" },{ 'id': 2, 'value': "Not Posted" }]}
                      component={renderAutoCompleteSingleSelect} />
                  </div>
                </div>
                <div className="row">
                  <div className="col-8 col-sm-8 col-md-8 reset-btn claims_btn"></div>
                  <div className="col-4 col-sm-4 col-md-4 btn_rt reset-btn claims_filter"> 
                    <RaisedButton disabled={this.state.selectedClaims.length>0?false:true} className={this.state.selectedClaims.length>0?"grey_btn mx-3" : "grey_btn reset-disable mx-3" }onTouchTap={this.bulkDownloadERADetails}>BULK DOWNLOAD</RaisedButton>    
                    <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                    <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                  </div>
                </div>
              </form>
              <div className="row">
                <div className="col-sm-12">
                  <div className="table-responsive mt-15">

                    <table className={tableClass}>

                      <thead>
                        <tr>
                          <th width="4%">
                            <span>Select</span>
                            <div className="table_custom-check">
                              <Field
                                name='Chkclaim'
                                component={renderCheckBox}
                                onChange={(e) => this.checkAllClaims(e)}
                                style={stylescss.checkbox}
                              />
                            </div>
                          </th>
                          <th width="8%">
                            <span>ERA Date</span>
                          </th>
                          <th width="8%">
                            <span>Clearinghouse Name</span>
                          </th>
                          <th width="8%">
                            <span>Check Date</span>
                          </th>
                          <th width="8%">
                            <span>Check Number</span>
                          </th>

                          <th width="8%">
                            <span>ERA Name</span>
                          </th>

                          <th width="8%">
                            <span>Payer</span>
                          </th>

                          <th width="8%">
                            <span>Total ERA Amount</span>
                          </th>

                          <th width="8%">
                            <span>Amount Posted</span>
                          </th>

                          <th width="8%">
                            <span>Amount Unposted</span>
                          </th>

                          <th width="8%">
                            <span>Payment posted date</span>
                          </th>

                          <th width="8%">
                            <span>Status</span>
                          </th>

                          <th width="8%">
                            <span>View ERA</span>
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.props.All_ERA_Claims && this.props.All_ERA_Claims.data && this.props.All_ERA_Claims.data.eRAResponseModels && this.props.All_ERA_Claims.data.eRAResponseModels.length ?
                            this.props.All_ERA_Claims.data.eRAResponseModels.map((Obj, index) => {
                              return (
                                <tr key={Obj.batchId}>
                                  <td colSpan="13">
                                    <table className={tableClass1}>
                                      <tbody>
                                        <tr >
                                          <td width="4%">
                                            <div className="table_custom-check">
                                              <Field
                                                name={`Claims[${index}].Chk`}
                                                component={renderCheckBox}
                                                onChange={(e) => this.CheckClaim(e,Obj,index)}
                                                style={stylescss.checkbox}
                                              />
                                            </div>
                                            <button onClick={(e) => this.handleExpandRow(Obj.batchId)} type="button" className="morebtn">
                                              <i ref={'expClass' + Obj.batchId} className="classExpand fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                          </td>
                                          <td width="8%">
                                            <span>{Obj.eraDate ? moment(Obj.eraDate).format('MM/DD/YYYY') : "NA"}</span>
                                          </td>
                                          <td width="8%">
                                            <span>{Obj.clearingHouseName ? Obj.clearingHouseName : "NA"}</span>
                                          </td>
                                          <td width="8%">
                                            <span>{Obj.checkDate ? moment(Obj.checkDate).format('MM/DD/YYYY') : "NA"}</span>
                                          </td>
                                          <td width="8%">
                                            <span>{Obj.checkNumber ? Obj.checkNumber : "NA"}</span>
                                          </td>

                                          <td width="8%">                                         
                                            <span>{Obj.eraName ?<Tooltip Description={Obj.eraName} /> : "NA"}</span>
                                          </td>

                                          <td width="8%">
                                            <span>{Obj.payer ? Obj.payer : "NA"}</span>
                                          </td>
                                          <td width="8%">
                                            <span>{Obj.totalERAAmount ? Obj.totalERAAmount : "NA"}</span>
                                          </td>

                                          <td width="8%">
                                            <span>{Obj.amountPosted ? Obj.amountPosted : "NA"}</span>
                                          </td>

                                          <td width="8%">
                                            <span>{Obj.amountUnposted ? Obj.amountUnposted : "NA"}</span>
                                          </td>

                                          <td width="8%">
                                            <span>{Obj.paymentPostedDate ? moment(Obj.paymentPostedDate).format('MM/DD/YYYY') : "NA"}</span>
                                          </td>
                                          <td width="8%">
                                            <span>{Obj.status ? Obj.status : "NA"}</span>
                                          </td>

                                          <td width="8%">
                                            {Obj.eraName ? <IconButton onClick={() => this.downloadERAFile(Obj.batchId, Obj.eraName)}>
                                              <i className="material-icons">file_download</i>
                                            </IconButton> : "ERA File Not Available"}

                                          </td>

                                        </tr>

                                        <tr className="nohover" ref={'expandedClass' + Obj.batchId} style={{ 'display': 'table-row' }}>
                                          <td></td>
                                          <td colSpan="12">
                                            <table className={tableClass2}>
                                              <thead>
                                                <tr>
                                                  <th width="11%">DOS</th>
                                                  <th width="11%">CL Number</th>
                                                  <th width="11%">Client Name</th>
                                                  <th width="11%">Payment</th>
                                                  <th width="11%">Amount Posted</th>
                                                  <th width="11%">Amount Unposted</th>
                                                  <th width="11%">Status</th>
                                                  <th width="11%">Posted/Not Posted</th>
                                                  <th width="11%">Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.props.All_ERA_Claims.data.eRAClaimsResponseModels.map((innerObj, index) => {
                                                if(innerObj.batchId=== Obj.batchId){
                                                  return (
                                                    <tr key={innerObj.clNumber}>
                                                      <td width="11%">{innerObj.dos ? moment(innerObj.dos).format('MM/DD/YYYY') : "NA"}</td>
                                                      <td width="11%">{innerObj.clNumber}</td>
                                                      <td width="11%">{innerObj.clientName ? innerObj.clientName : "NA"}</td>
                                                      <td width="11%">{innerObj.payment ? innerObj.payment : "NA"}</td>
                                                      <td width="11%">{innerObj.amountPosted ? innerObj.amountPosted : "NA"}</td>
                                                      <td width="11%">{innerObj.amountUnPosted ? innerObj.amountUnPosted : "NA"}</td>
                                                      <td width="11%">{innerObj.status ? innerObj.status : "NA"}</td>
                                                      <td width="11%">{innerObj.postedStatus ? innerObj.postedStatus : "NA"}</td>
                                                      <td width="11%">
                                                        {innerObj.postedStatus !== "Not Posted" ?
                                                          <IconButton title='Go to EDI Response' onClick={() => this.actionClickHandler(innerObj.dos,innerObj.clNumber)}>
                                                            <i className="material-icons">open_in_new</i>
                                                          </IconButton> : null
                                                        }
                                                      </td>
                                                    </tr>
                                                  )
                                                }
                                                })
                                                }

                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>

                              )
                            })
                            :
                            <tr>
                              <td colSpan="13">
                                <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                              </td>
                            </tr>
                        }
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManageERA = reduxForm({
  form: 'MANAGEERAFORM',
})(ManageERA);


function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLEARING_HOUSE');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLEARING_HOUSE_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLEARING_HOUSE_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLEARING_HOUSE_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLEARING_HOUSE_LIST_DELETE')[0].permission : hasDefaultAccess;

  // End For Role Permission
  return {
    All_ERA_Claims: state.Manage_ERA_Reducer.all_ERA_Claims,
    loading: state.Manage_ERA_Reducer.loading,
    masterData: state.staff_dashboard.master_data,
    All_EDI_GATEWAYS: state.Manage_ERA_Reducer.all_EDI_GATEWAYS
  };
}

export default connect(mapStateToProps, { bulk_Download_ERA_Details,getIscalledFromERAMouleFlag, get_All_ERA_Claims, getMasterData, get_EDI_GateWays, EDI835Download })(ManageERA);



// WEBPACK FOOTER //
// ./src/modules/ManageERA/index.js